<ui-title [title]="'User Roles Checker'">


</ui-title>

<ui-alert *ngIf="modalAlert.display" [title]="modalAlert.title" [text]="modalAlert.text"
	(onAction)="modalAlert.cb($event)"></ui-alert>

<div class="card">
	<div class="card-body row">
		<div class="col-lg-6">
			<form>
				<div class="form-group mat-autocomplete-large">
					<label class="col-form-label">
						User in Active Directory
					</label>
					<br/>


					<mat-form-field>

						<input [formControl]="users.newAlias.sorUserIdFormControl" (keydown)="user_dropdownType()" type="text" placeholder="Search"
							   aria-label="Number" matInput [matAutocomplete]="auto">

						<ui-loading *ngIf="users.searchingUserDropdown"></ui-loading>

						<mat-autocomplete panelWidth="'100%'" autoActiveFirstOption #auto="matAutocomplete"
							[displayWith]="autocompleteDisplayUser">
							<mat-option *ngFor="let item of  users.autocomplete$ | async; let index=index" [value]="item">
								{{ item.FirstName }} {{ item.LastName }} ({{ item.Login }})
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
				</div>
				<div class="form-group row">
					<label class="col-form-label">
						Date (optionnal)
					</label>
					<div class="">
						<button class="btn btn-primary" style="float:left"
								(click)="users.searchedDate=date_modify(users.searchedDate,'-');this.user_search()">
							&lt;
						</button>
						&nbsp;
						<input class="form-control" type="date" name="todate"
							style="float:left;width:200px;margin-left:5px;margin-right:5px"
							[(ngModel)]="users.searchedDate">
						&nbsp;
						<button class="btn btn-primary" style="float:left;margin-right:5px"
								(click)="users.searchedDate=null;this.user_search()">clear
						</button>
						&nbsp;
						<button class="btn btn-primary" style="float:left"
								(click)="users.searchedDate=date_modify(users.searchedDate,'+');this.user_search()">&gt;
						</button>


					</div>
				</div>
				<div class="form-group">
					<button class="btn btn-primary " style="margin-top:10px" (click)="user_search()">Search</button>
				</div>
			</form>
		</div>
		<!-- { "Id": 6494, "Login": "ACALVAYRAC", "IsActive": true, "IsPrivilegedAccount": false, "FirstName": "Aurélie", "
		LastName": "Calvayrac", "ADObjectId": "c398abb5-436d-4eff-b45b-f47ca007f32f", "UserPrincipalName": "Acalvayrac@tmhcc.com",
		"Title": "Senior Business Analyst", "Email": "ACALVAYRAC@tmhcc.com", "Office": "Barcelona, B", "Department": "Operations",
		"CreatedDate": "2025-02-06T14:03:52.0963913+01:00", "UpdatedDate": "2024-11-29T14:36:05.9099414", "ManagerId": 6266, "Manager": null,
		"OverridenManagerId": null, "OverridenManager": null, "OverridenManagerComments": null, "Country": "Spain" }
		-->
		<div class="col-lg-6 row" *ngIf="this.users.searchedUser?.Id">
			<label class="form-label col-lg-6">Email</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.Email}}
			</div>
			<label class="form-label  col-lg-6">Active?</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.IsActive?'Active':'Inactive'}}
			</div>
			<label class="form-label  col-lg-6">Privileged?</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.IsPrivilegedAccount?'Privileged':'Normal'}}
			</div>
			<label class="form-label  col-lg-6">UserPrincipalName</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.UserPrincipalName}}
			</div>
			<label class="form-label  col-lg-6">Title</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.Title}}
			</div>
			<label class="form-label  col-lg-6">Office</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.Office}}
			</div>
			<label class="form-label  col-lg-6">Country</label>
			<div class="col-lg-6">
				{{this.users.searchedUser.Country}}
			</div>
		</div>
	</div>
</div>

<div class="col-lg-12 mt-4">
	<ui-loading [loadingText]="'searching'" [loading]="users.searching"></ui-loading>

	<ui-table [chunker]="users.chunker" (chunked)="users.chunkedData = $event" [headers]="users.tableHeaders"
		[filters]="true">
		<tr *ngFor="let d of users.chunkedData">
			<td>{{ d.SystemName }}</td>
			<td>{{ d.Username }}</td>
			<td style="width:100px">{{ d.RoleName }}</td>
			<td>{{ d.MappedRoleName }}</td>
			<!-- AD Group Name — from systems_loaders.json AccessGroups via OPENJSON -->
			<td>{{ d.AdGroupName }}</td>
			<td *ngIf="!users.isSearchingWithDate" (click)="users_selectSearchDate(d.FirstReported)">
				{{ d.FirstReported|date }}
			</td>
			<td *ngIf="!users.isSearchingWithDate" (click)="users_selectSearchDate(d.LastReported)">
				{{ d.LastReported|date }}
			</td>
			<td *ngIf="users.isSearchingWithDate">N/A</td>

			<td *ngIf="users.isSearchingWithDate">N/A</td>


		</tr>
	</ui-table>

</div>
